module.exports = __webpack_public_path__ + "img/ball-r.dd1acba8.png";